import * as OrderTexts from '../../../../../../../intl'
import { Props } from './../../typings'

import { form } from '../../../../formState'

import { Eligibility } from './components/Eligibility'
import { RecurrenceSettings } from './components/RecurrenceSettings'

export function EligibilityAndReccurrence(props: Props) {
  const { isSimulation } = props

  return (
    <form.Fieldset data-testid="eligibility-and-reccurrence">
      <form.SectionTitle variant="alternative">
        {OrderTexts.geFieldLabelEligibilityAndRecurrenceText()}
      </form.SectionTitle>

      {!isSimulation && <RecurrenceSettings {...props} />}

      <Eligibility {...props} />
    </form.Fieldset>
  )
}
